// extracted by mini-css-extract-plugin
export default {"text2cols":"Affairs_text2cols__ctveE","text2colsLeft":"Affairs_text2colsLeft__qNGRp","text2colsRight":"Affairs_text2colsRight__m2QBC"};